export const ElectronicInvoiceMethod = Object.freeze({
  NAV_HASH: 'NAV_HASH',
  ESZIGNO: 'ESZIGNO',
});

export const electronicInvoiceMethodOptions = [
  { value: ElectronicInvoiceMethod.NAV_HASH, label: 'Hash mentése' },
  { value: ElectronicInvoiceMethod.ESZIGNO, label: 'e-Szignó' },
];
